import { useEffect } from 'react';
import { useUnit } from 'effector-react';
import clsx from 'clsx';
import { $dashboardSummaryStore, $initialCurrenciesAvailableStore, $profileFeatureStore } from '@lib/store';
import { AmountUtils, CurrencyUtils, PaletteUtils } from '@shared/utils';
import { DashboardSpendingCurrency } from './dashboardSpendingCurrency';
import { DashboardExpenseCategories } from './dashboardExpenseCategories';
import { DashboardMerchants } from './dashboardMerchants';
import { ColorsEnum, NoData, Spinner, Text } from '@shared/widgets';
import styles from './tab.module.scss';

export const CardTab = () => {
  const profileFeatureStore = useUnit($profileFeatureStore.store);
  const dashboardSummaryStore = useUnit($dashboardSummaryStore.store);
  const currencyByAccountStore = useUnit($initialCurrenciesAvailableStore.store);

  useEffect(() => {
    if (!profileFeatureStore.data?.dashboard.viewCurrenciesSummary) return;
    $dashboardSummaryStore.events.update();
  }, [profileFeatureStore]);

  return (
    <>
      {!profileFeatureStore.data ? (
        <NoData />
      ) : profileFeatureStore.loading || dashboardSummaryStore.loading || currencyByAccountStore.loading ? (
        <Spinner />
      ) : (
        dashboardSummaryStore.data.length > 0 && (
          <div className='flex flex-col gap-6'>
            <Text weight='medium' size='2xl'>
              Currencies ({dashboardSummaryStore.data.length})
            </Text>
            {dashboardSummaryStore.data.map((item, idx) => {
              const symbol = CurrencyUtils.getSymbolByCode(item.currency);
              return (
                <div key={idx} className='flex pr-12 bg-white dark:bg-soft-black'>
                  <div className='pr-12'>
                    <div className={clsx(styles['currency__icon'], PaletteUtils.isVcfcPalette && styles.vcfc)} data-icon={symbol}>
                      <div
                        className={clsx(
                          styles['currency__icon-cut'],
                          'w-1/2 h-[150%] border-l bg-white dark:bg-soft-black absolute bottom-[-2px] left-[calc(100%-2px)] origin-bottom-left rotate-[-20deg]',
                          PaletteUtils.isInsigniaPalette && 'border-primary',
                          PaletteUtils.isVcfcPalette && 'border-sand dark:border-primary',
                        )}
                      />
                    </div>
                  </div>
                  <div className='w-full py-4 flex items-center justify-around gap-6 max-[1100px]:grid max-[1100px]:grid-cols-1 max-[1100px]:gap-3'>
                    <div className='flex flex-col'>
                      <Text size='2xl'>{item.accounts}</Text>
                      <Text weight='medium' color={ColorsEnum.Secondary}>
                        Accounts
                      </Text>
                    </div>
                    <div className='flex flex-col'>
                      <Text size='2xl'>{item.cards}</Text>
                      <Text weight='medium' color={ColorsEnum.Secondary}>
                        Cards
                      </Text>
                    </div>
                    <div className='flex flex-col'>
                      <Text size='2xl'>{AmountUtils.transformToAmountWithCurrency(item.availableBalance, item.currency)}</Text>
                      <Text weight='medium' color={ColorsEnum.Secondary}>
                        Available balance
                      </Text>
                    </div>
                    <div className='flex flex-col'>
                      <Text size='2xl'>{AmountUtils.transformToAmountWithCurrency(item.amountDue, item.currency)}</Text>
                      <Text weight='medium' color={ColorsEnum.Secondary}>
                        Amount due
                      </Text>
                    </div>
                    <div className='flex flex-col'>
                      <Text size='2xl'>{AmountUtils.transformToAmountWithCurrency(item.totalLimit, item.currency)}</Text>
                      <Text weight='medium' color={ColorsEnum.Secondary}>
                        Total limit
                      </Text>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )
      )}
      {profileFeatureStore.data?.dashboard.viewSpendingByCurrency && <DashboardSpendingCurrency />}
      {profileFeatureStore.data?.dashboard.viewExpenseCategories && <DashboardExpenseCategories />}
      {profileFeatureStore.data?.dashboard.viewMostUsedMerchants && <DashboardMerchants />}
    </>
  );
};
